import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/api';

export const fetchWebhooks = createAsyncThunk(
  'webhooks/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.webhooks.getAll();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createWebhook = createAsyncThunk(
  'webhooks/create',
  async (webhookData, { rejectWithValue }) => {
    try {
      const response = await apiService.webhooks.create(webhookData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// New: fetch events for a specific webhook
export const fetchWebhookEvents = createAsyncThunk(
  'webhooks/fetchEvents',
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const response = await apiService.webhooks.getEvents(id, params);
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  webhooks: [],
  webhookEvents: {}, // keyed by webhookId
  loading: false,
  loadingEvents: false,
  error: null,
};

const webhooksSlice = createSlice({
  name: 'webhooks',
  initialState,
  reducers: {
    updateWebhookStatus: (state, action) => {
      const { id, status, lastEvent } = action.payload;
      const webhook = state.webhooks.find(w => w.id === id);
      if (webhook) {
        webhook.status = status;
        webhook.lastEvent = lastEvent;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    clearWebhookEvents: (state, action) => {
      const id = action.payload;
      delete state.webhookEvents[id];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebhooks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWebhooks.fulfilled, (state, action) => {
        state.loading = false;
        state.webhooks = action.payload.data || action.payload;
      })
      .addCase(fetchWebhooks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createWebhook.fulfilled, (state, action) => {
        state.webhooks.push(action.payload);
      })
      .addCase(fetchWebhookEvents.pending, (state) => {
        state.loadingEvents = true;
      })
      .addCase(fetchWebhookEvents.fulfilled, (state, action) => {
        state.loadingEvents = false;
        const { id, data } = action.payload;
        state.webhookEvents[id] = data.data || data;
      })
      .addCase(fetchWebhookEvents.rejected, (state, action) => {
        state.loadingEvents = false;
        state.error = action.payload;
      });
  },
});

export const { updateWebhookStatus, clearError, clearWebhookEvents } = webhooksSlice.actions;
export default webhooksSlice.reducer;

